'use strict';

module.exports = {
	hyphenToCamelCase: function (value) {
		return value.replace(/-([a-z])/gi, function (s, g) { return g.toUpperCase(); } );
	}
};